var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"top-0 left-0 w-full p-4 lg:p-0",class:_vm.classes},[_vm._t("default",null,{"closePopup":_vm.closePopup})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }